import { AxiosError } from 'axios';

import { FDD_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { Fdd } from '@/types/fdd.type';
import { ApiResponse } from '@/types/response.type';

export const getFdd = async (): Promise<ApiResponse<Fdd>> => {
  try {
    const response = await apiManager.get(FDD_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
